// extracted by mini-css-extract-plugin
export default {"search":"oFxXS5DNxUac7xYbvonx","clearSearch":"DlQSU4E9yfHyePSi2A5y","placeHolderShimmer":"QD7Tfj93NZHS_vpyzCNA"};